module.exports = __webpack_public_path__ + "77dc69fe56b65a76b174d8061db74a1a.pdf";